const snum = Math.floor(Math.random() * 100) + 1;


export default snum;